import{tokeniseString as r}from"./tokeniseString.js";import{transformToPlaybackTitleCase as o}from"./transformToPlaybackTitleCase.js";var t=function(t){return r(t).map(o).join(" ")};export{t as playbackTitleCase};
//# sourceMappingURL=playbackTitleCase.js.map
